<template>
  <div class="ma-1">
    <p class="section-header">{{ section.name }}</p>
    <div class="mb-1" style="border: 1px dotted #dddddd; background: #ffffff; border-radius: 5px" v-for="group in section.groups" :key="group">
      <div v-for="(report, index) in group.reports" :key="report">
        <template v-if="CheckReport(report)">
          <v-alert class="pl-5 pr-0 pt-2 pb-2 mb-5" style="border-radius: 5px; background: #ffffff;" border="start" border-color="#8BC34A" elevation="2" :id="`report_${group.guid}_${report.report_guid}`">
            <p>
              {{ report.report_description }}
              <span v-if="report.report_object && report.report_object.guid">{{ report.report_object.name }}</span>
              <span v-if="report.report_time && report.report_time.guid">{{ report.report_time.name === 'offline' ? 'в нерабочее время' : 'в рабочее время' }}</span>
            </p>
            <template v-slot:append>
              <p style="line-height: 1; text-align: right">
                <code style="cursor: pointer; color: #8BC34A; font-size: 10px" v-on:click="copyElement(report.report_guid)">{{ report.report_guid }}</code><br>
                <span style="font-size: 10px; opacity: 0.7;">UUID: {{ report.unique_guid }}</span>
              </p>
            </template>
          </v-alert>
          <div>
            <ChartHandler v-if="checkHandler(report)" mode="edit" :current="preparedReportData(report)" :index="index" :pattern="getPattern(group.reports)" />
          </div>
          <div class="grow" style="color: #353535 !important; border-radius: 5px;">
            <v-textarea style="background: #ffffff; border-radius: 5px;" label="Пояснительная записка" v-model="report.description_note" />
          </div>
        </template>
        <template v-else>
          <v-alert class="pl-5 pr-0 pt-2" style="border-radius: 5px; background: #ffffff;" border="start" border-color="#FF5722" elevation="2" :id="`report_${group.guid}_${report.report_guid}`">
            Отчёт "{{ report.report_description }}" не имеет данных, либо все данные равны нулю!<br>График не отображается и не добавляется в отчёт!
            <template v-slot:append>
              <code style="cursor: pointer; color: #FF5722; font-size: 10px" v-on:click="copyElement(report.report_guid)">{{ report.report_guid }}</code>
            </template>
          </v-alert>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ChartHandler from "@/components/Reports/ChartHandler";
import { CurrentData, CurrentDialog } from "@/store/report/CurrentDialogData";
import copy from 'copy-to-clipboard';
import { Allerts } from "@/store/global/Allerts";
import randomstring from "randomstring";
import reportCreate from "../../views/reports/create/reportCreate.vue";
import { CheckReport } from "@/libs/report_checker";
import { report_dep } from "../../store/Dashboard/productivity";

export default {
  name: "ViewerElement",
  components: { ChartHandler },
  props: [ 'section' ],
  methods: {
    report_dep,
    CheckReport,
    checkHandler: function (report) {
      let checker = this.$rep_cfg.charts.find(chart => chart.guid === report.report_guid)
      if (checker) return true
      return false
    },
    generateDescriptionString: function (reports) {
      // Проверяем сколько будет записок скомбинированно
      let count = 0
      for (let report of reports) {
        if (report.description_note) {
          count++
        }
      }
      let note = ''

      switch (count) {
        case 0:
          return false;
        case 1:
          return reports[0].description_note
        case 2:
        case 3:
          for (let [index, report] of reports.entries()) {
            note+=`Пояснительная записка к ${index+1} графику:\n`
            note+=report.description_note
          }
          return note
      }
    },
    getPattern: function(reports) {
      let description = this.generateDescriptionString(reports)
      let legend = {
        status: false,
        position: null
      }
      for (let [index, report] of reports.entries()) {
        let tmp = this.$rep_cfg.charts.find(chart => chart.guid === report.report_guid)
        if (tmp.legend) {
          legend = {
            status: true,
            position: index
          }
        }
      }
      switch (reports.length) {
        case 0:
          return 'empty'
        case 1:
          if (this.$rep_cfg.patterns.find(pattern => pattern.name === 'multipage').charts.includes(reports[0].report_guid)) {
            return 'multipage_empty'
          } else if (legend.status === true && description === true) {
            return 'single_legend-note'
          } else if (legend.status === true && description === false) {
            return 'single_legend'
          } else if (legend.status === false && description === true) {
            return 'single_note'
          } else {
            return 'single_empty'
          }
        case 2:
          if (legend.status === true && description === true) {
            return 'double_legend-note'
          } else if (legend.status === true && description === false) {
            return 'double_legend'
          } else if (legend.status === false && description === true) {
            return 'double_note'
          } else {
            return 'double_empty'
          }
        case 3:
          if (description === true) {
            return 'triple_note'
          } else {
            return 'triple_empty'
          }
      }
    },
    generateUUID: function (guid) {
      return guid+'_'+randomstring.generate(16)
    },
    CheckObject: function (element) {
      const chart = this.$rep_cfg.charts.find(el => el.guid === element['report_guid'])
      if (chart && chart.has_objects) return true
      return false
    },
    copyElement: function (guid) {
      copy(guid)
      Allerts().warn('СКОПИРОВАН', `GUID ${guid} скопирован!`,'light-green', 'clipboard')
    },
    preparedReportData(report) {
      let tmp = this.$rep_cfg.charts.find(chart => chart.guid === report.report_guid)
      let data = {
        uuid: report.unique_guid,
        guid: report.report_guid,
        name: report.report_description,
        scale: tmp.needSpace,
        hasLegend: tmp.hasLegend ? true : false,
        raw_data: report
      }
      return data
    },
  },
  computed: {
    reportCreate() {
      return reportCreate
    },
    page() {
      return this.pages
    },
    current: {
      get() {
        return CurrentData().get()
      },
      set(value) {
        CurrentData().set(value)
      }
    },
    dialog: {
      get() {
        return CurrentDialog().get()
      },
      set(value) {
        CurrentDialog().set(value)
      }
    }
  }
}
</script>

<style scoped>
.section-header {
  text-align: center;
  font-family: 'DinCyB', sans-serif;
  font-size: 24px;
}
</style>
